import { useTabsContext } from "@chakra-ui/react"
import { useShareUIContext } from "../shared/ShareUIContextProvider"
import { shareSections } from "../tabs/ShareTabs"
import SelectEmails from "./SelectEmails"
import SelectPeople from "./SelectPeople"
import { useSelectPeopleContext } from "./SelectPeopleContext"

function SelectItems() {
  const {
    items,
    search,
    itemsState: { loading }
  } = useSelectPeopleContext()
  // Determine if the "Add" tab is selected, auto-focusing the select input if so.
  const { selectedIndex } = useTabsContext()
  const { clickedTabIndex } = useShareUIContext()
  const addTabIndex = shareSections.findIndex((s) => s.key === "add")
  // Auto-focus when selected "Add" tab index matches the clicked tab index.
  const autoFocus =
    selectedIndex === addTabIndex && selectedIndex === clickedTabIndex

  return items.length || search || loading ? (
    <SelectPeople autoFocus={autoFocus} />
  ) : (
    <SelectEmails />
  )
}

export default SelectItems
